export default __webpack_public_path__ + "static/media/m3_element_yellow.adac2c88.png";